// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"242":"supervisor","412":"provider","818":"registrator"}[chunkId] + "." + {"242":"0b6dac7e","412":"0b6dac7e","818":"0b6dac7e"}[chunkId] + ".css";
};